// extracted by mini-css-extract-plugin
export var label = "_i6-0";
export var treatmentCard = "_i6-1";